import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-flexible-accordion-content.scss'
import {renderAccordions} from '@/scripts/modules/detail-accordion'

export default register(`section-flexible-accordion-content`, {
    onLoad() {
        renderAccordions(`section-flexible-accordion-content`, true, true)
    },
    onUnload() {

    },
})
